import { createAction } from "redux-actions";

import {
  GET_MONITORING_QUEUE_ENTRIES,
  GET_MONITORING_QUEUE_ENTRIES_COUNT,
  SET_MONITORING_QUEUE_ENTRY_SEARCH_FILTERS,
  GET_MONITORING_QUEUE_ENTRY_DETAILS,
  SET_MONITORING_QUEUE_ENTRY_CURRENT_PAGE,
  SET_MONITORING_QUEUE_ENTRY_ITEMS_PER_PAGE,
  SET_MONITORING_QUEUE_TABLE_CHECKBOX_CHECKED,
  SET_TABLE_HEADER_DROPDOWN_VALUE,
  SET_SELECTED_ENTRIES,
  SET_DESELECTED_ENTRIES,
  SET_MONITORING_QUEUE_ENTRY_NO_ENTRIES_MESSAGE,
} from "../types";
import createAsyncActions from "../../../utilities/createAsyncActions";

export const {
  getMonitoringQueueEntries,
  getMonitoringQueueEntriesPending,
  getMonitoringQueueEntriesFulfilled,
  getMonitoringQueueEntriesRejected,
} = createAsyncActions(
  GET_MONITORING_QUEUE_ENTRIES,
  "getMonitoringQueueEntries"
);

export const {
  getMonitoringQueueEntriesCount,
  getMonitoringQueueEntriesCountPending,
  getMonitoringQueueEntriesCountFulfilled,
  getMonitoringQueueEntriesCountRejected,
} = createAsyncActions(
  GET_MONITORING_QUEUE_ENTRIES_COUNT,
  "getMonitoringQueueEntriesCount"
);

export const {
  getMonitoringQueueEntryDetails,
  getMonitoringQueueEntryDetailsPending,
  getMonitoringQueueEntryDetailsFulfilled,
  getMonitoringQueueEntryDetailsRejected,
} = createAsyncActions(
  GET_MONITORING_QUEUE_ENTRY_DETAILS,
  "getMonitoringQueueEntryDetails"
);

export const setSearchFilters = createAction(
  SET_MONITORING_QUEUE_ENTRY_SEARCH_FILTERS
);
export const setCurrentPage = createAction(
  SET_MONITORING_QUEUE_ENTRY_CURRENT_PAGE
);
export const setItemsPerPage = createAction(
  SET_MONITORING_QUEUE_ENTRY_ITEMS_PER_PAGE
);
export const setTableCheckboxChecked = createAction(
  SET_MONITORING_QUEUE_TABLE_CHECKBOX_CHECKED
);
export const setTableHeaderDropdownValue = createAction(
  SET_TABLE_HEADER_DROPDOWN_VALUE
);
export const setSelectedEntries = createAction(SET_SELECTED_ENTRIES);
export const setDeselectedEntries = createAction(SET_DESELECTED_ENTRIES);
export const setNoEntriesMessage = createAction(
  SET_MONITORING_QUEUE_ENTRY_NO_ENTRIES_MESSAGE
);



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/actions/getMonitoringQueueEntriesActions.js